import React from 'react';
import { observer } from 'mobx-react';
import {
  IconType, ButtonProps, Icon,
} from '@routific/hive';
import { useTranslation } from 'react-i18next';
import { RouteProps } from '../../../../store/mst/utils/getRoutesProps';
import ActionButton, { CommonActionTypes, ButtonTypes } from '../../../shared/ActionButton';
import { useStore } from '../../../../store/mst';

interface Props {
  routeProps: RouteProps;
  type?: ButtonTypes;
  buttonProps?: ButtonProps;
}

const ReverseButton: React.FC<Props> = ({ routeProps, type, buttonProps }) => {
  const store = useStore();
  const {
    isStarted, disabled, noOrders, isLocked, isLoading, isReversing,
  } = routeProps;

  const { t } = useTranslation('components');

  const onClickHandler = (e?: any) => {
    e.stopPropagation?.();
    store.model.reverseRoute(routeProps.uuids);
  };

  const getTooltipTitle = () => {
    if (disabled || noOrders) {
      if (isStarted) {
        return t('moreActionsButton.route.button.reverse.tooltip.isStarted');
      }
      if (isLocked || isLoading || isReversing) {
        return t('publish.tooltip.routeLocked');
      }
      if (noOrders) {
        return t('moreActionsButton.route.button.reverse.tooltip.noOrders');
      }
      return t('moreActionsButton.route.button.reverse.tooltip.noPermission');
    }
    if (type === ButtonTypes.BUTTON) {
      return t('moreActionsButton.route.button.reverse.tooltip.button');
    }
    return undefined;
  };

  return (
    <>
      <ActionButton
        name={CommonActionTypes.REVERSE}
        tooltipProps={{
          title: getTooltipTitle(),
        }}
        type={type}
        disabled={disabled || noOrders}
        menuItemText={t('moreActionsButton.route.button.reverse.text')}
        menuItemProps={{
          onClick: onClickHandler,
          icon: <Icon icon={IconType.Reverse} />,
        }}
        buttonProps={{
          icon: IconType.Reverse,
          style: { pointerEvents: isStarted ? 'none' : 'auto' },
          onClick: onClickHandler,
          ...buttonProps,
        }}
      />
    </>
  );
};

export default observer(ReverseButton);
